export const LICENSE_LOADED = 'LICENSE_LOADED';
export const LICENSE_LOADING = 'LICENSE_LOADING';
export const LICENSE_ERROR = 'LICENSE_ERROR';

// New license management actions
export const LOAD_LICENSES = 'LOAD_LICENSES';
export const LOAD_LICENSES_SUCCESS = 'LOAD_LICENSES_SUCCESS';
export const LOAD_LICENSES_FAILURE = 'LOAD_LICENSES_FAILURE';

export const CREATE_LICENSE = 'CREATE_LICENSE';
export const CREATE_LICENSE_SUCCESS = 'CREATE_LICENSE_SUCCESS';
export const CREATE_LICENSE_FAILURE = 'CREATE_LICENSE_FAILURE';

export const DELETE_LICENSE = 'DELETE_LICENSE';
export const DELETE_LICENSE_SUCCESS = 'DELETE_LICENSE_SUCCESS';
export const DELETE_LICENSE_FAILURE = 'DELETE_LICENSE_FAILURE';

export const LOAD_PRICING_TIERS = 'LOAD_PRICING_TIERS';
export const LOAD_PRICING_TIERS_SUCCESS = 'LOAD_PRICING_TIERS_SUCCESS';
export const LOAD_PRICING_TIERS_FAILURE = 'LOAD_PRICING_TIERS_FAILURE'; 